export default function PageNotFound() {
  return (
    <>
      <div className="px-4 py-16 sm:px-6 sm:py-24 grid place-items-center mt-44 lg:px-8">
        <div className="mx-auto max-w-max">
          <main className="sm:flex">
            <p className="text-4xl font-bold tracking-tight text-teal-400 sm:text-5xl">
              404
            </p>
            <div className="sm:ml-6">
              <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
                  Page not found
                </h1>
                <p className="mt-1 text-base text-gray-500">
                  Please check the URL in the address bar and try again.
                </p>
              </div>
              <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                <a
                  href="/"
                  className="inline-flex items-center rounded-md border border-transparent bg-teal-500 px-4 py-2 text-sm font-medium text-black shadow-sm hover:text-white focus:ring-teal-400 focus:ring-offset-2"
                >
                  Go back home
                </a>
                <a
                  href="mailto:seanrk06@icloud.com"
                  className="inline-flex items-center rounded-md border border-transparent bg-none outline outline-white outline-1 px-4 py-2 text-sm font-medium text-white hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-offset-2"
                >
                  Contact Me
                </a>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
